<template>
  <ul v-if="items" class="space-y-0.5">
    <template v-for="(item, i) of items" :key="i">
      <li v-if="visible(item) && !item.separator">
        <!-- Router link item -->
        <router-link
          v-if="item.to"
          :to="item.to"
          @click="onMenuItemClick($event, item, i)"
          class="flex items-center gap-3 px-5 py-2.5 text-sm font-body text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface rounded-lg mx-2 transition-colors"
          active-class="!bg-primary/10 !text-primary font-semibold"
        >
          <i :class="item.icon" class="text-base w-5 text-center"></i>
          <span class="flex-1">{{ item.label }}</span>
          <i v-if="item.items" class="pi pi-fw pi-angle-down text-xs transition-transform" :class="{ 'rotate-180': activeIndex === i }"></i>
          <span v-if="item.badge" class="ml-auto w-5 h-5 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">{{ item.badge }}</span>
        </router-link>

        <!-- Anchor / group header -->
        <a
          v-if="!item.to"
          :href="item.url || '#'"
          @click="onMenuItemClick($event, item, i)"
          class="flex items-center gap-3 px-5 py-2.5 text-sm font-body text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface rounded-lg mx-2 transition-colors cursor-pointer"
          :class="{ '!bg-primary/10 !text-primary font-semibold': activeIndex === i }"
        >
          <i :class="item.icon" class="text-base w-5 text-center"></i>
          <span class="flex-1">{{ item.label }}</span>
          <i v-if="item.items" class="pi pi-fw pi-angle-down text-xs transition-transform" :class="{ 'rotate-180': activeIndex === i }"></i>
        </a>

        <!-- Submenu children -->
        <transition
          enter-active-class="transition-all duration-300 ease-in-out overflow-hidden"
          leave-active-class="transition-all duration-200 ease-in overflow-hidden"
          enter-from-class="max-h-0 opacity-0"
          enter-to-class="max-h-96 opacity-100"
          leave-from-class="max-h-96 opacity-100"
          leave-to-class="max-h-0 opacity-0"
        >
          <div v-show="activeIndex === i" class="pl-4">
            <appsubmenu
              :claims="claims"
              :user-email="userEmail"
              :items="visible(item) && item.items"
              @menuitem-click="$emit('menuitem-click', $event)"
            />
          </div>
        </transition>
      </li>

      <!-- Separator -->
      <li v-if="visible(item) && item.separator" :key="'separator' + i"
        class="mx-5 my-2 border-t border-surface-container-high" role="separator"></li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'appsubmenu',
  props: {
    items: Array,
    root: { type: Boolean, default: false },
    claims: Object,
    userEmail: { type: String, default: '' },
  },
  data() {
    return { activeIndex: null }
  },
  methods: {
    onMenuItemClick(event, item, index) {
      if (item.disabled) { event.preventDefault(); return; }
      if (!item.to && !item.url) { event.preventDefault(); }
      if (item.command) { item.command({ originalEvent: event, item: item }); }
      this.activeIndex = index === this.activeIndex ? null : index;
      this.$emit('menuitem-click', { originalEvent: event, item: item });
    },
    visible(item) {
      if (item.role) {
        if (!this.claims) return false;
        if (!item.role.some(r => this.claims[r])) return false;
      }
      if (item.email) {
        const email = (this.userEmail || '').toLowerCase();
        if (!email || !item.email.map(e => e.toLowerCase()).includes(email)) return false;
      }
      return true;
    }
  }
}
</script>
